
<footer class="footer" [ngClass]="extraClass" [class.footer--login]="showLogos">
  <div class="container">
    @if (showLogos) {
      <div class="footer__login-bar" [class.footer__login-bar--no-brand]="!showBrandImage">
        <div class="footer__login-left">
          <span class="footer__copyright" aria-label="Declaration">
            {{ 'copyrightText' | translate:translations }} &copy; 2024 Five Areas Ltd. {{ 'allrightsreservedText' | translate:translations }}.
          </span>
        </div>
        @if (showBrandImage) {
          <div class="footer__login-center">
            <img
              src="assets/footer-bb.png"
              alt="BounceBack logo"
              class="footer__brand-image" />
            </div>
          }
          <div class="footer__login-right">
            <nav class="navigation-links" aria-label="Footer navigation">
              <a routerLink="/aboutus">{{ 'aboutUsText' | translate:translations }}</a>
              <span class="navigation-links__separator" aria-hidden="true">|</span>
              <a routerLink="/privacy-policy">{{ 'privacyPolicyText' | translate:translations }}</a>
              <span class="navigation-links__separator" aria-hidden="true">|</span>
              <a routerLink="/contact-us">{{ 'contactUsText' | translate:translations }}</a>
            </nav>
          </div>
        </div>
      } @else {
        <div class="contact-us-heading">
          <span aria-label="Declaration">
            {{ 'copyrightText' | translate:translations }} &copy; 2024 Five Areas Ltd. {{ 'allrightsreservedText' | translate:translations }}.
          </span>
          <nav class="navigation-links" aria-label="Footer navigation">
            <a routerLink="/aboutus">{{ 'aboutUsText' | translate:translations }}</a>
            <span class="navigation-links__separator" aria-hidden="true">|</span>
            <a routerLink="/privacy-policy">{{ 'privacyPolicyText' | translate:translations }}</a>
            <span class="navigation-links__separator" aria-hidden="true">|</span>
            <a routerLink="/contact-us">{{ 'contactUsText' | translate:translations }}</a>
          </nav>
        </div>
      }

    </div>
  </footer>

